var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0949 22.3386C5.82755 19.1551 0 13.8963 0 8.92414C0 0.617384 7.975 -2.48424 14.5 3.93077C21.025 -2.48424 29 0.617384 29 8.92272C29 13.8963 23.171 19.1551 18.9051 22.3386C16.9737 23.7786 16.008 24.5 14.5 24.5C12.992 24.5 12.0263 23.78 10.0949 22.3386ZM21.025 5.0884C21.3134 5.0884 21.59 5.19996 21.794 5.39852C21.9979 5.59709 22.1125 5.8664 22.1125 6.14722V7.91191H23.925C24.2134 7.91191 24.49 8.02346 24.694 8.22203C24.8979 8.4206 25.0125 8.68991 25.0125 8.97072C25.0125 9.25154 24.8979 9.52085 24.694 9.71942C24.49 9.91798 24.2134 10.0295 23.925 10.0295H22.1125V11.7942C22.1125 12.075 21.9979 12.3444 21.794 12.5429C21.59 12.7415 21.3134 12.853 21.025 12.853C20.7366 12.853 20.46 12.7415 20.256 12.5429C20.0521 12.3444 19.9375 12.075 19.9375 11.7942V10.0295H18.125C17.8366 10.0295 17.56 9.91798 17.356 9.71942C17.1521 9.52085 17.0375 9.25154 17.0375 8.97072C17.0375 8.68991 17.1521 8.4206 17.356 8.22203C17.56 8.02346 17.8366 7.91191 18.125 7.91191H19.9375V6.14722C19.9375 5.8664 20.0521 5.59709 20.256 5.39852C20.46 5.19996 20.7366 5.0884 21.025 5.0884Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector-1.56e8c10f8a4429af25f7403be131d7f2.svg";
export { ForwardRef as ReactComponent };